import { ICONS } from 'components/Icon';
import { AssetFromSync } from 'store/assets/types';
import { User, UserOrganisationNew } from 'store/auth/types';
import { AssetError } from 'store/error/types';
import { Organisation } from 'store/organisations/types';
import { EPReportsGetPages } from 'types/Endpoints/Reports';

export type SyncResponse = {
  assets: Record<string, AssetFromSync>;
  organisations: Record<string, Partial<Organisation>>;
  asset_errors?: Record<string, AssetError>;
  timestamp: number;
  user?: User;
  deleteAssets?: string[];
  forceDeleteAssets?: string[];
  urlToken?: string;
  appUpdateAvailable: false | 'major' | 'minor';
  organisation: UserOrganisationNew | null;

  offlineOnly: boolean | undefined;
  pages: EPReportsGetPages['response']['pages'];

  userOrganisations?: Record<
    string,
    {
      id: string;
      uuid: string;
      isMain: boolean;
      features: {
        setupfields: boolean;
        setupassessments: boolean;
        setupcategories: boolean;
        setupseverities: boolean;
        setuptimescales: boolean;
        setupbilling: boolean;
        editassetdetails: boolean;
        editassetfields: boolean;
        viewassetfields: boolean;
        editassetplans: boolean;
      };
      details?: {
        name: string;
        svgLogo: string | null;
        pngLogo: string | null;
        address1: string;
        address2: string;
        city: string;
        county: string;
        postcode: string;
        phone: string;
      };
    }
  >;
};

export interface SyncState {
  flagKeyShouldDownloadCleanAssetData: number;
  flagValueShouldDownloadCleanAssetData: number;
  flagKeyShouldDownloadCleanOrganisationData: number;
  flagValueShouldDownloadCleanOrganisationData: number;
  downloadCleanData: boolean;

  serverTimestamp: number;
  asset_timestamps: Record<string, number>;
  organisation_timestamps: Record<string, number>;
  asset_removal_queue: string[];
  files_upload_queue: string[];

  downloadedFilesQueue: Record<string, string>;
  downloadedFiles: Record<string, string>;

  downloadedThumbnailsQueue: Record<string, string>;
  downloadedThumbnails: Record<
    string,
    string | { assetId: string; width: number; height: number }
  >;

  pauseBgNetwork: number;
  skipBgNetworkUntilTime: number;
  nextBgDataSyncTime: number;
  skipBgDataSyncUntilTime: number;
  skipBgErrorUploadUntilTime: number;
  lastBgDataSyncTime?: number;

  syncStatus: {
    step: SyncSteps;
    text: string;
    count: number;
    icon: ICONS | null;
  };
  syncErrors: {
    [SyncSteps.data]: string;
    [SyncSteps.fileDownload]: string;
    [SyncSteps.fileUpload]: string;
    [SyncSteps.thumbnailDownload]: string;
  };

  assetIdsToDownload: string[];
  doManualSync: boolean;
  nextAppUpdateCheckTime: number;
  appUpdateAvailable: false | 'major' | 'minor';

  // @REMOVE type after 2022-03-01 – wait for local data to be updated
  thumbnails_download_queue?: Record<string, string> | undefined;
  thumbnails_downloaded?: Record<string, string> | undefined;
}

export enum SyncSteps {
  waiting = 'waiting',
  finished = 'finished',
  data = 'data',
  fileUpload = 'fileUpload',
  fileDownload = 'fileDownload',
  thumbnailDownload = 'thumbnailDownload',
}
